import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Menu, MenuItem, MenuItemStyles } from 'react-pro-sidebar'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import { AdvancedModeSwitch } from '../../components/AdvancedModeSwitch/AdvancedModeSwitch'
import { ZocksAcademyMenuItem } from '../../components/ZocksAcademy/ZocksAcademyMenuItem'
import { useZocksAuth, useZocksQuota } from '../../components/ScopedBlock/hooks'
import { Divider } from '../../components/Divider/Divider'

import { useAccount } from '../../common/useAccount'

import { EnterpriseDashboardMenu } from './EnterpriseDashboardMenu'
import { useTrackedMenuItem } from './useTrackedMenuItem'

import './SidebarFooter.scss'

export interface SidebarFooterProps {
  collapsed: boolean
  menuItemStyles: MenuItemStyles
  onItemClick?: () => void
}

export const SidebarFooter: React.FC<SidebarFooterProps> = ({ collapsed, menuItemStyles, onItemClick }) => {
  const { hasQuota } = useZocksQuota()
  const { hasScope } = useZocksAuth()
  const { account } = useAccount()

  const enterpriseDashboardAvailable = hasQuota('app.enterpriseDashboard.value')
  const hasSubAccountAdminScope = hasScope('**', 'sub_account:admin', ['sub_account:admin'])
  const hasDashboardListScope = hasScope('**', 'dashboard:list', ['dashboard:admin'])

  const handleMenuItemClick = useTrackedMenuItem(onItemClick)

  const hasDownstreamAccess = !!account?.effectiveConfig?.downstreamDashboards || !!account?.effectiveConfig?.downstreamInsights
  const isEnterpriseDashboardEnabled = (enterpriseDashboardAvailable && hasSubAccountAdminScope) || (hasDownstreamAccess && hasDashboardListScope)

  return (
    <div className={classNames({ 'd-none': collapsed })}>
      <Divider className='zocks-bg-color-gray-800 zocks-mb-1 zocks-mt-0 divider-sidebar-bottom-fixed' />
      <Container fluid className='zocks-px-1.25 zocks-lg-pb-1'>
        <Row className='m-0 d-flex'>
          <Col xs={8} sm={12} className='p-0'>
            <AdvancedModeSwitch />
          </Col>
          {isEnterpriseDashboardEnabled ? (
            <Col xs={8} sm={12} className='p-0'>
              <EnterpriseDashboardMenu menuItemStyles={menuItemStyles} />
            </Col>
          ) : null}
          <Col xs={8} sm={12} className='p-0'>
            <Menu menuItemStyles={menuItemStyles} className='zocks-menu'>
              <ZocksAcademyMenuItem />
            </Menu>
          </Col>
          <Col xs={8} sm={12} className='p-0'>
            <Menu menuItemStyles={menuItemStyles} className='zocks-menu'>
              <MenuItem
                onClick={() => handleMenuItemClick('helpCenter')}
                icon={<i className='bi bi-question-circle' />}
                component={<Link className='ps-menu-button' to='https://help.zocks.io' target='_blank' rel='noreferrer' />}
              >
                <div className='button-small'>Help center</div>
              </MenuItem>
            </Menu>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
